/**
 * useFocusActions - Focus mode action handlers
 */

import { useCallback, useRef } from 'react';

export function useFocusActions({
  selectedNodes,
  setSelectedNodes,
  handleFocusTasks,
  handleFocusTask,
}) {
  // Use a ref to always get the latest selectedNodes to avoid stale closure issues
  const selectedNodesRef = useRef(selectedNodes);
  selectedNodesRef.current = selectedNodes;
  
  const focusSelectedTasks = useCallback(() => {
    const currentSelectedNodes = selectedNodesRef.current;
    if (currentSelectedNodes.size > 0) {
      handleFocusTasks(Array.from(currentSelectedNodes));
      setSelectedNodes(new Set());
    }
  }, [handleFocusTasks, setSelectedNodes]);

  const handleFocusTaskWithClear = useCallback((taskId) => {
    handleFocusTask(taskId);
    setSelectedNodes(new Set());
  }, [handleFocusTask, setSelectedNodes]);

  return {
    focusSelectedTasks,
    handleFocusTaskWithClear,
  };
}

export default useFocusActions;
